
 


 

  
import React,{useContext, useState,useEffect} from 'react'
import {Link, useNavigate,useParams} from 'react-router-dom'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {UserContex} from '../App'
import Header from '../components/Header';
import Payment from './FundraiserPayment';
import { name } from '@cloudinary/url-gen/actions/namedTransformation';
import { loadStripe } from'@stripe/stripe-js';
import {socket} from "../App"
import Footer from '../components/Footer';
// import { CardElement, Elements, useElements } from
 
// '@stripe/react-stripe-js';

// const stripePromise = loadStripe('pk_test_51O7H4NFtdms7xyPvenr9xBB9Hor425E614fYOEv0vCgo9ygKGSVezMIfQWcg8Rhef7I2APPt1PMC4lfdz3TnHtLT00idMMp6pq');

const Fundraiser = ()=>{
  const {state, dispatch }= useContext(UserContex)
  const history =useNavigate();
  const [email,setEmail] =  useState("");
  const [name,setName] =  useState("");
  const [phone,setPhone] =  useState("");
  const [amount,setAmount] =  useState();
  const [password,setPassword] =  useState("");
  const [billing,setBilling] =  useState(false);
  const [policy,setPolicy] =  useState(false);
  const [payment,setPayment] =  useState(false);
  const [freeEvent,setFreeEvent] =  useState(false);
  const [seats,setSeats] =  useState(0);
  const [size,setSize] =  useState(0);
  const navigate= useNavigate()

  const [data,setData]= useState([])
  const [cart,setCart]= useState([])
  const [details,setDetails]= useState([])
  const [column, setColumn] = useState("")
  const [booked,setBooked] = useState([])
  const [taken,setTaken] = useState([])
const {postid} = useParams()
// const elements = useElements()

// setColumn("grid-cols-"+data.col) 

// console.log("Booked",cart)

// if(booked.length>0){
//     localStorage.setItem("data", JSON.stringify(booked));

// }


//  useEffect(() => {

//     fetch(`/getsinglemembership/${postid}`, {
//         headers: {
//           Authorization: "Bearer " +localStorage.getItem("jwt"),
//           "Content-Type":"application/json"
//           }
//     })
//         .then(res => res.json())
//         .then(result => {
//             setData(result.event);
           
//         });


   
        


// }, []);
 

       

    

const [isOpen, setIsOpen] = useState(false);

    
const Policyitems = [
    { title: "Nature of Donation", content: "This is a voluntary contribution and not a purchase, transaction, or exchange for goods/services unless explicitly stated. Your donation is non-refundable and non-transferable." },
    { title: "Full Consent:", content: "You are making this donation willingly, under no coercion, and in full understanding of its purpose as described in the campaign." },
    { title: "Accuracy of Information:", content: "You certify that all personal details (e.g., name, email, contact information) provided are correct and complete. It is your responsibility to ensure this information is accurate. If you do not receive the promised link or communication after the campaign concludes due to incorrect/incomplete details, the organization bears no liability." },
    { title: "No Refunds:", content: "All donations are final. No refunds, reimbursements, or exchanges will be issued under any circumstances, as contributions are made voluntarily and irrevocably." },
    { title: "Post-Campaign Communication: ", content: "The delivery of the link or any post-campaign material is contingent on the campaign’s successful completion and your compliance with these terms. While we strive to fulfill commitments, technical or operational delays may occur. Check spam/junk folders before contacting support." },
    { title: "No Guarantees: ", content: " Donations do not guarantee specific outcomes unless explicitly stated in the campaign. The organization reserves the right to allocate funds as deemed appropriate for the cause." }
  ];
 
 
 

    return(

<>
<main class="bg-white h-screen  relative overflow-x-hidden">
    <div class="flex items-start justify-between">
       
        <div class="flex flex-col w-full ">

            

            <Header></Header>


            


<div class="relative md:block lg:block hidden">

<img src="bann.jpeg" class="absolute h-full w-full object-cover"/>
{/* <div class="absolute inset-0 bg-purple-500 opacity-50"></div> */}
<div class="absolute inset-0 overflow-hidden">
    <div class="absolute inset-0 bg-gradient-to-r from-black to-transparent"></div>
  </div>



   
    </div>


    



        </div>
     

    </div>



  

   
<div class="flex flex-col">

<img src="fund.jpeg" class="absolute h-1/2 w-full object-cover object-top overflow-hidden"/>
{/* 
<video autoPlay loop muted playbackRate={2.0}  class=" absolute h-1/2 w-full object-fill md:h-1/2  md:w-full md:object-cover">
<source src="https://v4.cdnpk.net/videvo_files/video/free/video0467/large_watermarked/_import_614f00b3e16dc1.55454574_FPpreview.mp4" type="video/mp4" />
</video> */}
<div>
<h2 class="relative text-3xl mt-24 font-extrabold text-black dark:text-white sm:text-4xl text-center">
            <span class="block">
            "The Messenger"
            <br></br>
            
            </span>
        </h2>
<video  loop controls playbackRate={2.0}  
  class=" relative h-60 w-11/12 md:h-96 md:w-1/2 object-center rounded-lg 
         flex justify-center items-center mx-auto mt-24 ">
            <source src="https://res.cloudinary.com/dthdfdatk/video/upload/v1741969979/mes_mi5v1o.mp4" type="video/mp4" />
</video> 
{/* <img src={data.pic?data.pic:"https://img.freepik.com/free-psd/sound-party-cover-template_23-2148131763.jpg?size=626&ext=jpg&ga=GA1.1.1697546048.1698228343&semt=sph" } class=" relative h-60 w-11/12 ml-4 md:h-96 md:w-1/2 object-center md:ml-80  md:mt-24 mt-32 rounded-lg "/>  */}

</div>





 {/* <div class=" relative flex  mx-auto">

         <img src="https://img.freepik.com/free-photo/excited-audience-watching-confetti-fireworks-having-fun-music-festival-night-copy-space_637285-559.jpg?w=996&t=st=1698228712~exp=1698229312~hmac=e6d992326774f5a0d719062875e0439936f46b09ea558d4d295af285dc06e732" class=" w-full h-92"/>
 </div>
  */}






<h2 class="text-3xl font-extrabold text-black dark:text-white sm:text-4xl text-center">
            <span class="block">
            "In Honor of One Hour"
            <br></br>
             Crowd Funding 2026 Campaign 
            </span>
        </h2>
<div class="w-full md:p-12  bg-white overflow-auto  mb-4 relative">


  <div class="  text-center  bg-white  rounded  ">
      <div class="md:flex md:items-center md:justify-center md:h-full">
         
          
          

<div class="p-14 mx-auto text-center  bg-gray-100 border-indigo-500 rounded shadow-lg   ">
      <div class="flex items-center justify-center h-full">
         
          
          
<div class="flex flex-col justify-center w-full  space-y-3 md:flex-row md:w-full md:space-x-3 md:space-y-0">
    <div class=" relative ">
        <input type="text"  class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none ring-2 ring-purple-600 focus:border-transparent" placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        />
        </div>
    <div class=" relative ">
        <input type="text"  class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none ring-2 ring-purple-600 focus:border-transparent" placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        />
        </div>
    <div class=" relative ">
        <input type="text"  class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none ring-2 ring-purple-600 focus:border-transparent" placeholder="Phone No."
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        />
        </div>
    <div class=" relative ">
        <input type="number"  class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none ring-2 ring-purple-600 focus:border-transparent" placeholder="Donation Amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        />
        </div>

        <button 
  class={`flex-shrink-0 px-4 py-2 text-base font-semibold text-white 
          bg-purple-600 rounded-lg shadow-md 
          hover:bg-purple-700 focus:outline-none 
          focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 
          focus:ring-offset-purple-200 
          ${!name || !email || !amount || !phone|| amount<30 ? "opacity-50 cursor-not-allowed" : ""}`}
  onClick={() => setPolicy(true)}
  disabled={!name || !email || !amount ||!phone}
>
  Donate
</button>



        {/* <button class="flex-shrink-0 px-4 py-2 text-base font-semibold text-white bg-purple-600 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200" 
                      onClick={()=>{setBilling(true)}}


        >
            Donate
        </button> */}
    </div>
    

         
      </div>

       <div className='text-start mt-4 text-red-500'>
       * Name, Email and Amount (Standard $30) should be added to Proceed

        </div>         

  </div>

      </div>
  </div>




 
</div>


<section class="bg-purple-500 m-8 rounded-lg">
    <div class="container grid grid-cols-2 gap-8  py-8 mx-auto text-center md:grid-cols-4">
        <div>
            <h5 class="text-3xl font-bold text-white">
                <span class="inline text-white">
             AU $80,000 (US $50,000)                </span>
                <span class="text-indigo-200">
                    +
                </span>
            </h5>
            <p class="text-xs font-medium tracking-wide text-indigo-100 uppercase">
            Funding Goal            </p>
        </div>
        <div>
            <h5 class="text-3xl font-bold text-white">
                <span class="inline text-white">
              Mar 15 – April 20, 2025                </span>
                <span class="text-indigo-200">
                    
                </span>
            </h5>
            <p class="text-xs font-medium tracking-wide text-indigo-100 uppercase">
            Funding Window            </p>
        </div>
        <div>
            <h5 class="text-3xl font-bold text-white">
                <span class="inline text-white">
               AUD 30 Per Person
                </span>
                <span class="text-indigo-200">
                    
                </span>
            </h5>
            <p class="text-xs font-medium tracking-wide text-indigo-100 uppercase">
            Pledge
            </p>
        </div>
        <div>
            <h5 class="text-3xl font-bold text-white">
                <span class="inline text-white">
              2,667 People
                </span>
                <span class="text-indigo-200">
                    +
                </span>
            </h5>
            <p class="text-xs font-medium tracking-wide text-indigo-100 uppercase">
            Minimum no. of Supporters:
            </p>
        </div>
    </div>
   
</section>


<div class="bg-white dark:bg-gray-800 overflow-hidden relative lg:flex lg:items-center">
    <div class="w-full py-12 px-4 sm:px-6 lg:py-16 lg:px-8 z-20">
        <h2 class="text-3xl font-extrabold text-black dark:text-white sm:text-4xl">
            <span class="block">
            Crowd Funding 2026 Campaign 
            <br></br>
            "The Messenger"
            </span>
        </h2>
        <p class="text-md mt-4 text-gray-400">
        For the past 4 years, I’ve been collecting Himalayan glacier ice inside a discarded plastic bottle to
symbolize the disappearing glaciers of Bhutan. During this time, a student in remote Bhutan gave
me a letter addressed to the world leaders. I promised her and said, “I will try my best to get your
message, across to the leaders or the concerned people during my journey going forward”. Today,
as “the messenger”
, I bring the bottle and the letters with me, as I ride across Australia
representing the voices of the Bhutanese youth, and the youth the world over, in delivering their
messages.
          </p>
        <p class="text-md mt-4 text-gray-400">
        The campaign is currently raising funds for the next edition, where I will collect glacier water from 2
of the world’s 7 summits, which is Mt. Kilimanjaro in Africa and Mt. Aconcagua in South America.
The last glaciers on Mt. Kilimanjaro are set to disappear within the next few years and we want to
leverage this urgency with the dying Himalayan glaciers and call for urgent action from world
leaders. The fundraising event will remain open during the month-long duration of the Australia
campaign.
          </p>
        <div class="lg:mt-0 lg:flex-shrink-0">
            <div class="mt-12 inline-flex rounded-md shadow">
                {/* <button type="button" class="py-2 px-4  bg-green-500 hover:bg-green-700 focus:ring-green-500 focus:ring-offset-green-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                    Get started
                </button> */}
            </div>
        </div>
    </div>
    <div class="flex items-center gap-8 p-8 lg:p-24">
        
                    <img src="/pc2.jpeg" class="w-1/2 rounded-lg" alt="Tree"/>

        
        <div>
            <img src="/pc1.jpeg" class="mb-8 rounded-lg" alt="Tree"/>
            <img src="/pc3.jpeg" class="rounded-lg" alt="Tree"/>
        </div>
    </div>
</div>


<div class="relative max-w-screen-xl p-4 px-4 mx-auto bg-white dark:bg-gray-800 sm:px-6 ">
    <div class="relative">
        <div class="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div class="ml-auto lg:col-start-2 lg:max-w-2xl">
                <p class="text-base font-semibold leading-6 text-indigo-500 uppercase">
                In light of this, I am aware of the sacrifice the Bhutanese living abroad are making for their children
and families, back home.          </p>
                <h4 class="mt-2 text-2xl font-extrabold leading-8 text-gray-900 dark:text-white sm:text-3xl sm:leading-9">
                In honor of this sacrifice, the campaign would like to make a humble
                proposal:                       </h4>
                <p class="mt-4 text-lg leading-6 text-gray-500 dark:text-gray-300">
                If you pledge “One Hour” of your daily wage towards the campaign, we will release an educational
and environmental documentary series on YouTube, that the students all over Bhutan can freely
access. The series covers the 2022 biking trip to Thorthormi glacier in Lunana where you will also
get to see many inspiring everyday Bhutanese who have left remarkable impacts in the community.
We will also credit your name in the upcoming documentary film, among other rewards.                </p>
                <ul class="gap-6 mt-8 md:grid md:grid-cols-1">
                    <li class="mt-6 lg:mt-0">
                        <div class="flex">
                            <span class="flex items-center justify-center flex-shrink-0 w-6 h-6 text-green-800 bg-green-100 rounded-full dark:text-green-500 drark:bg-transparent">
                                <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd">
                                    </path>
                                </svg>
                            </span>
                            <span class="ml-4 text-base font-medium leading-6 text-gray-500 dark:text-gray-200">
                             Online viewing link of the Australia campaign documentary.

                           </span>
                        </div>
                    </li>
                    <li class="mt-6 lg:mt-0">
                        <div class="flex">
                            <span class="flex items-center justify-center flex-shrink-0 w-6 h-6 text-green-800 bg-green-100 rounded-full dark:text-green-500 drark:bg-transparent">
                                <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd">
                                    </path>
                                </svg>
                            </span>
                            <span class="ml-4 text-base font-medium leading-6 text-gray-500 dark:text-gray-200">
                            Onscreen ‘Special Thanks’ credit                            </span>
                        </div>
                    </li>
                    <li class="mt-6 lg:mt-0">
                        <div class="flex">
                            <span class="flex items-center justify-center flex-shrink-0 w-6 h-6 text-green-800 bg-green-100 rounded-full dark:text-green-500 drark:bg-transparent">
                                <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd">
                                    </path>
                                </svg>
                            </span>
                            <span class="ml-4 text-base font-medium leading-6 text-gray-500 dark:text-gray-200">
                            Online viewing link of 19-episode                            </span>
                        </div>
                    </li>
                    <li class="mt-6 lg:mt-0">
                        <div class="flex">
                            <span class="flex items-center justify-center flex-shrink-0 w-6 h-6 text-green-800 bg-green-100 rounded-full dark:text-green-500 drark:bg-transparent">
                                <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd">
                                    </path>
                                </svg>
                            </span>
                            <span class="ml-4 text-base font-medium leading-6 text-gray-500 dark:text-gray-200">
                            Directors Cut                           </span>
                        </div>
                    </li>
                    <li class="mt-6 lg:mt-0">
                        <div class="flex">
                            <span class="flex items-center justify-center flex-shrink-0 w-6 h-6 text-green-800 bg-green-100 rounded-full dark:text-green-500 drark:bg-transparent">
                                <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd">
                                    </path>
                                </svg>
                            </span>
                            <span class="ml-4 text-base font-medium leading-6 text-gray-500 dark:text-gray-200">
                            Short film                                                                     </span>
                        </div>
                    </li>
                    <li class="mt-6 lg:mt-0">
                        <div class="flex">
                            <span class="flex items-center justify-center flex-shrink-0 w-6 h-6 text-green-800 bg-green-100 rounded-full dark:text-green-500 drark:bg-transparent">
                                <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd">
                                    </path>
                                </svg>
                            </span>
                            <span class="ml-4 text-base font-medium leading-6 text-gray-500 dark:text-gray-200">
                            Original Gyalsey                                                                                      </span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="relative mt-10 lg:-mx-4 relative-20 lg:mt-0 lg:col-start-1">
                <div class="relative space-y-4">
                    <div class="flex items-end justify-center space-x-4 lg:justify-start">
                        <img class="w-32 rounded-lg shadow-lg md:w-56" width="200" src="pc4.jpeg" alt="1"/>
                        <img class="w-40 rounded-lg shadow-lg md:w-64" width="260" src="pc5.jpeg" alt="2"/>
                    </div>
                    <div class="flex items-start justify-center ml-12 space-x-4 lg:justify-start">
                        <img class="w-24 rounded-lg shadow-lg md:w-40" width="170" src="pc6.jpeg" alt="3"/>
                        <img class="w-32 rounded-lg shadow-lg md:w-56" width="200" src="pc7.jpeg" alt="4"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


{
billing? 
(
<>
<div
className="justify-center md:p-44 items-center flex   fixed inset-0 z-50 outline-none focus:outline-none overflow-auto"
>
 {/*content*/}
 <div className=" border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
   {/*header*/}
   <div className="flex rounded-full items-start  ">
     
     <button
       className="p-1 ml-auto rounded-full bg-white text-white text-3 "
       onClick={() => setBilling(false)}
     >
<svg class="h-8 w-8 text-red-500"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round">  <circle cx="12" cy="12" r="10" />  <line x1="15" y1="9" x2="9" y2="15" />  <line x1="9" y1="9" x2="15" y2="15" /></svg>

</button>
   </div>
   {/*body*/}
  
   


   <div className="text-gray-500 rounded-3xl shadow-xl w-full mb-5" >
<div className="md:flex w-full">
 
 <div className="w-full md:h-96    px-5 md:px-10 relative overflow-auto">

<Payment   amount={amount} vendor={"acct_1PVV5sQvXR47R2Mq"} id={postid} email={email} name={name} phone={phone}/>


</div>


   </div>

 
 </div>



 

</div>


</div>
</>
)


:null

}
{
policy? 
(
<>
<div
className="justify-center md:p-44 items-center flex   fixed inset-0 z-50 outline-none focus:outline-none overflow-auto"
>
 {/*content*/}
 <div className=" border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
   {/*header*/}
   <div className="flex rounded-full items-start  ">
     
     <button
       className="p-1 ml-auto rounded-full bg-white text-white text-3 "
       onClick={() => setBilling(false)}
     >
<svg class="h-8 w-8 text-red-500"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round">  <circle cx="12" cy="12" r="10" />  <line x1="15" y1="9" x2="9" y2="15" />  <line x1="9" y1="9" x2="15" y2="15" /></svg>

</button>
   </div>
   {/*body*/}
  
  <div className='p-8'>
  By proceeding with this payment, you confirm that you have read, understood, and agree to the following terms:  

  </div>
   




   <div className="text-gray-500 rounded-3xl shadow-xl w-full mb-5" >
<div className="md:flex w-full">
 
 <div className="w-full md:h-96    px-5 md:px-10 relative overflow-auto">

    {Policyitems.map((items,index)=>{

        return(
            <div className="border-b border-gray-300">
            <button
              className="w-full flex justify-between items-center p-4 text-left font-medium bg-gray-100 hover:bg-gray-200 transition"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span>{items.title}</span>
              <span className="text-xl font-bold">{isOpen ? "−" : "+"}</span>
            </button>
            <div
              className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                isOpen ? "max-h-40" : "max-h-0"
              }`}
            >
              <div className="p-4 text-gray-700">{items.content}</div>
            </div>
          </div>
      
        )
    })}


<div className='m-8'>
Contact Support:  
For questions or issues, reach out to 08 9454 4245 before proceeding.  

By continuing, you acknowledge full acceptance of this disclaimer.


</div>


</div>


   </div>

  
 </div>
 <button 
  class={` text-center m-2 px-4 py-2 text-base font-semibold text-white 
          bg-purple-600 rounded-lg shadow-md 
          hover:bg-purple-700 focus:outline-none 
          focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 
          focus:ring-offset-purple-200 
          `}
  onClick={() => {setPolicy(false); setBilling(true)}}
>
  Proceed to payment
</button>


 

</div>


</div>
</>
)


:null

}

</div>
        
<div className="m-16 flex justify-center items-center">
    <img className="h-1/2 w-3/4" src="/iti.png" alt="Image" />
</div>












<Footer page="events"></Footer>
</main>







</>

  


    );
}

export default Fundraiser;